$(document).ready(function () {

	updateComparisons();
	$('#compareProduct').removeClass('tw-hidden');
 
	// ====================================== // 
	// Compare Functionality 
	// ====================================== // 
	$('#compareProduct').click(function(e) {
        e.preventDefault();
		var productHandle = $(this).data('product-handle'); 
		var compareButton = $(this); 

		compareProduct(productHandle, compareButton); 
        return false;
	}); 
});

function showToast(message) { 
	var toast = document.getElementById("toast"); 
	var toastMessage = document.getElementById("toast-message"); 
	toastMessage.textContent = message; 
	toast.className = "toast show"; 
	setTimeout(function() { toast.className = toast.className.replace("show", ""); }, 3000); 
} 

// ====================================== // 
// Compare Page and Functionality 
// ====================================== // 
// Function that saves the handle of the product to a productsToCompare 
// jSON object in the localstorage 
function compareProduct( $productHandle, $compareButton ) { 
	// Check if a comparison list already exists in local storage 
	let productsToCompare = localStorage.getItem('productsToCompare'); 
	
    // Parse the existing compare list 
	productsToCompare = JSON.parse(productsToCompare);

	// Create a new compare list with the product ID 
	if(!productsToCompare) {
		productsToCompare = [$productHandle]; 
		localStorage.setItem('productsToCompare', JSON.stringify(productsToCompare)); 
		showToast('Product added for comparison!');
		updateButton($productHandle, productsToCompare);
	
		// Add class to link the user to the page after adding
		$compareButton.addClass('linkToPage'); 
		return;
    }

    if ( $compareButton.hasClass('linkToPage') ) {
        return window.location.href = '/pages/compare-products';
    }

    if( productsToCompare.length >= 4 && !productsToCompare.includes($productHandle)) {
        //
        $compareText = $compareButton.find('#compareText');
        $compareButton.addClass('linkToPage'); 
        //
        $compareText.text('Click to see comparison table'); 
        // Alert the user
        showToast('You can only select 4 products to compare at once');

        return;
    }

    // Add the product handle to the list 
    productsToCompare.push($productHandle); 

    // Save the updated list back to localStorage
    localStorage.setItem('productsToCompare', JSON.stringify(productsToCompare)); 

    // Alert the user
    showToast('Product added for comparison!');

	// Update the button to reflect the localStorage
	updateButton($productHandle, productsToCompare);
	
	// Add class to link the user to the page after adding
	$compareButton.addClass('linkToPage'); 

	return;
} 

function updateButton(productHandle, productsToCompare) {

	$checkMark = $('#checkmark');
	$compareText = $('#compareText');

    if (productsToCompare.includes(productHandle)) { 
        $checkMark.removeClass('tw-hidden'); 
        $compareText.text('Click to see comparison table'); 

    } else { 
        $checkMark.addClass('tw-hidden'); 
        $compareText.text('Add to Product Comparison'); 
    } 
}

// Function to update product item classes based on local storage 
function updateComparisons() {

    $compareButton = $('#compareProduct'); 
    $productHandle = $('#compareProduct').data('product-handle'); 
    $compareText = $compareButton.find('#compareText');

    $compareButton.removeClass('linkToPage'); 
	let productsToCompare = localStorage.getItem('productsToCompare');

    if (!productsToCompare) { 
        return;
    }
 
    // Parse the existing compare list 
    productsToCompare = JSON.parse(productsToCompare); 

    if( productsToCompare.length >= 4 && !productsToCompare.includes($productHandle)) {
        //
        $compareButton.addClass('linkToPage'); 
        //
        $compareText.text('Click to see comparison table'); 

        return;
    }

    // Update the button to reflect the localStorage
    updateButton($productHandle, productsToCompare);
} 

async function getProductDataCompare(productHandle) {
	// If no product ID, exit
	if (!productHandle) {
		return;
	}

	let data = {};

	const JSONdata = await $.getJSON(
		window.Shopify.routes.root + 'products/' + productHandle + '.js',
		function (data) {
			return data;
		}
	);

	data = {
		...JSONdata,
	};

	const HTMLdata = await $.get(
		window.Shopify.routes.root + 'products/' + productHandle,
		function (data) {
			return data;
		}
	);
	const parsedHTML = $.parseHTML(HTMLdata);
	const $compareDataEle = $('[data-compare]', parsedHTML);

	if (!$compareDataEle) {
		return data;
	}

	const compareData = JSON.parse($compareDataEle.html());

	data = {
		...data,
		...compareData,
	};

	return data;
}

// Function that loads the products that are being compared in from the local storage to the page 
async function loadComparisons() {

	let productsToCompare = localStorage.getItem('productsToCompare'); 
	const $productsContainer = $('#comparison-container');
	const $comparisonGrid = $('#comparison-grid');
	
	// If no products to compare
	if (!productsToCompare) { 
		$('#loading-block').addClass('tw-hidden');
		$('#noProducts').removeClass('tw-hidden');
		return;
	}
 
	const productOptionsPromises = []; 
	productsToCompare = JSON.parse(productsToCompare); 
 
	$(productsToCompare).each(function() { 
		const dataPromise = getProductDataCompare(this); 
		productOptionsPromises.push(dataPromise); 
	}); 
 
	// Wait for all promises to resolve 
	const productOptions = await Promise.all(productOptionsPromises);
	
	populateCompareGrid($productsContainer, productOptions);

	// Count how many items are in the comparison
	const compareCount = productsToCompare.length;
	if( compareCount < 4 ) {
		var emptyNumber = 4 - compareCount;

		for (var i = 0; i < emptyNumber; i++) {
			const $templateForEmpty = $('#productComparisonEmpty'); 
			// Clone the product template 
			const $emptyProductDiv = $templateForEmpty.clone().removeClass('tw-hidden'); 
			// Append the populated product div to the compare div 
			$productsContainer.append($emptyProductDiv); 
		}
	}
	// Remove the loading indicator
	$('#loading-block').remove();
	$comparisonGrid.removeClass('tw-hidden');

	// If mobile, display the arrow for scrolling
	if( $(window).width() < 1140 ) {
		$('#mobileArrow').removeClass('tw-hidden');
	}

	// Remove cloned div
    $productComparisonDivs = $productsContainer.find('div#productCompareModal');
    
    // Remove divs that do not have the 'cloned' class
    $productComparisonDivs.not('.cloned').remove();
 
} 

function populateCompareGrid($productsContainer, productOptions) { 

	// Get the product template HTML 
	const $template = $('#productCompareModal');

	productOptions.forEach(data => { 
		const { featured_image, handle, title, price, url, height, width, depth, capacity, weight, lockType, warranty, tags } = data; 

		// Clone the product template 
		const $productDiv = $template.clone().addClass('cloned'); 
			 
		// 
		$('[data-modal-body]', $productDiv).removeClass('hidden'); 
	
		// Set where each item needs to be 
		const $productTitle = $('h4[data-product-title]', $productDiv); 
		const $productPrice = $('[data-product-price]', $productDiv); 
		const $productLink = $('[data-product-link]', $productDiv); 
		const $productImageRemove = $('[data-remove]', $productDiv ); 
		const $productImage = $('img[data-product-image]', $productDiv); 
		const $productSize = $('[data-product-size]', $productDiv); 
		const $productCapacity = $('[data-product-capacity]', $productDiv); 
		const $productWeight = $('[data-product-weight]', $productDiv); 
		const $productExpander = $('[data-product-expander]', $productDiv); 
		const $productLockType = $('[data-product-lock-type]', $productDiv); 
		const $productWarranty = $('[data-product-warranty]', $productDiv); 
	
		// Remove button
		$productImageRemove.on('click', function() { 
			let productHandle = $(this).data('product-handle'); 
			// Remove from front end
			$(this).parents('#productCompareModal').remove();
			// Remove from localStorage
			removeCompareItem(productHandle, $productsContainer);
        }); 
	
		// Product Image 
		$productImage.attr('src', featured_image);
		$productImageRemove.attr('data-product-handle', handle);
	
		// Product Title 
		$('[data-content]', $productTitle).html(title); 

		// Product Size
        let productSizeData =  width + ' x ' + height + ' x ' + depth + ' cm';

        if( title.toLowerCase().includes('set of') ) {
            productSizeData =  'Multiple';
        }

		if( !productSizeData || productSizeData === '' ) {
			$('[data-content]', $div).html(' - '); 
		} else {
			$('[data-content]', $productSize).html(productSizeData); 
		}

		// Product Capacity
		emptyDataTextCheck($productCapacity, capacity, 'litres');

		// Product Weight
		emptyDataTextCheck($productWeight, weight, 'kg');

		// Product Expandable
		const lowerCaseTags = tags.map(tag => tag.toLowerCase());
		$('[data-content]', $productExpander).html(lowerCaseTags.includes('expandable') ? 'Yes' : 'No');

		// Product Lock Type
		emptyDataTextCheck($productLockType, lockType);

		// Product Warranty
		emptyDataTextCheck($productWarranty, warranty);
	
		// Product Price 
		$('[data-content]', $productPrice).html( 
			'£'+Shopify.formatMoney(price, window.Shopify.current_money_format) 
		); 
	
		// Product shop now link 
		$('[data-product-url]', $productLink).attr('href', url); 	
	
		// Append the populated product div to the compare div 
		$productsContainer.prepend($productDiv); 
	
	});
}

function emptyDataTextCheck($div, data, unit) {
    let content = ' - ';
    if (data && data !== '' && unit) {
        content = data + ' ' + unit;
    } else if(data && data !== '' && !unit) {
        content = data;
	}
    $('[data-content]', $div).html(content);
}

function removeCompareItem(productHandle, $productsContainer) {
	const $templateForEmpty = $('#productComparisonEmpty'); 
	// Clone the product template 
	const $emptyProductDiv = $templateForEmpty.clone(); 
	
	// Get the current productsToCompare from local storage 
    var productsToCompare = localStorage.getItem('productsToCompare'); 
    if (!productsToCompare) return; 
    productsToCompare = JSON.parse(productsToCompare); 
 
	// Remove the product ID to the list 
	productsToCompare = productsToCompare.filter(function(id) {  
		return id !== productHandle;  
	}); 
 
    // Update local storage 
    localStorage.setItem('productsToCompare', JSON.stringify(productsToCompare)); 
	showToast('Product removed from your favourites!');  

	// Append the populated product div to the compare div 
	$productsContainer.append($emptyProductDiv); 
}

function initializeComparisons() {
	loadComparisons();
}